import punycode from 'punycode';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import beGetClientSmsText from 'actions/sms/beGetClientSmsText.action';
import IMG_07_WEEKS from 'assets/images/basket/client-connect/7weeks.svg';
import IMG_12_WEEKS from 'assets/images/basket/client-connect/12weeks.svg';
import IMG_24_WEEKS from 'assets/images/basket/client-connect/24weeks.svg';
import IMG_CAKE from 'assets/images/basket/client-connect/BirthdayCake.svg';
import IMG_DEPOSIT from 'assets/images/basket/client-connect/coin.svg';
import IMG_SETUP from 'assets/images/basket/client-connect/How-setup-icon.svg';
import IMG_NEW_CLIENT from 'assets/images/basket/client-connect/NewClientPrompt.svg';
import IMG_REBOOK from 'assets/images/basket/client-connect/RebookPrompt.svg';
import IMG_REVIEW from 'assets/images/basket/client-connect/ReviewPrompt.svg';
import IMG_STATUS from 'assets/images/basket/client-connect/Status-icon.svg';
import IMG_TERMS from 'assets/images/basket/client-connect/Terms-icon.svg';
import { getNcobRedirectUrl } from 'bl/ncob/getNcobRedirectUrl.bl';
import Space from 'components/generic/Space.component';
import SmsBundle from 'components/price/SmsBundle.component';
import DELAY from 'constants/delay.const';
import ELID from 'constants/elid.const';
import S from 'constants/string.const';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withTranslation } from 'providers/GILT.provider';
import { formatDayToYearFullWeekdaySuffix, formatPartTime } from 'utils/date/format.util';
import delayed from 'utils/functions/delayed.util';
import { modifyUrl } from 'utils/links/modify.util';

import {
  enableDisable7Week,
  enableDisable12Week,
  enableDisable24Week,
  enableDisableBday,
  enableDisableNewClient,
  enableDisableRebook,
  enableDisableThankyou,
  set7weekText,
  set12weekText,
  set24weekText,
  setBdayText,
  setDepositText,
  setNewClientText,
  setRebookText,
  setThankyouText,
} from 'clientCommunications/actions';
import Text7week from 'clientCommunications/components/ClientConnect/text/Text7week.component';
import Text12week from 'clientCommunications/components/ClientConnect/text/Text12week.component';
import Text24week from 'clientCommunications/components/ClientConnect/text/Text24week.component';
import TextBday from 'clientCommunications/components/ClientConnect/text/TextBday.component';
import TextNewClient from 'clientCommunications/components/ClientConnect/text/TextNewClient.component';
import TextRebook from 'clientCommunications/components/ClientConnect/text/TextRebook.component';
import { TextThankYou } from 'clientCommunications/components/ClientConnect/text/TextThankYou.component';
import Tooltip7week from 'clientCommunications/components/ClientConnect/tooltips/Tooltip7week.component';
import Tooltip12week from 'clientCommunications/components/ClientConnect/tooltips/Tooltip12week.component';
import Tooltip24week from 'clientCommunications/components/ClientConnect/tooltips/Tooltip24week.component';
import TooltipBday from 'clientCommunications/components/ClientConnect/tooltips/TooltipBday.component';
import TooltipCounter from 'clientCommunications/components/ClientConnect/tooltips/TooltipCounter.component';
import TooltipNewClient from 'clientCommunications/components/ClientConnect/tooltips/TooltipNewClient.component';
import TooltipRebook from 'clientCommunications/components/ClientConnect/tooltips/TooltipRebook.component';
import TooltipTextarea from 'clientCommunications/components/ClientConnect/tooltips/TooltipTextarea.component';
import TooltipThankYou from 'clientCommunications/components/ClientConnect/tooltips/TooltipThankYou.component';
import { getSalonOnlineSettings } from 'settings/online-booking/actions';

import TextDeposit from './text/TextDeposit.component';
import TooltipDeposit from './tooltips/TooltipDeposit.component';
import ToggleSmsButton from './ToggleSmsButton.component';

class ClientConnectLayout extends React.Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
    this.state = {
      defaultRebookMessage: '',
      defaultTankYouMessage: '',
      defaultNewClientMessage: '',
      default7weekMessage: '',
      default12weekMessage: '',
      default24weekMessage: '',
      defaultBdayMessage: '',
      defaultDepositMessage: '',
      enableDisable: this.props.clientSmsText && this.props.clientSmsText.enable_sms_rebook_prompt_text,
      enableDisableThankyouBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_thank_you_text,
      enableDisableNewClientBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_new_client_thank_you_text,
      enableDisable7WeekBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_lapsed_7_weeks_text,
      enableDisable12WeekBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_lapsed_12_weeks_text,
      enableDisable24WeekBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_lapsed_24_weeks_text,
      enableDisableBdayBox: this.props.clientSmsText && this.props.clientSmsText.enable_sms_bday_clients_text,
      showTextModal: false,
      numOfMessage: 1,
      charLenLimitReached: false,
      cursorPosition: { start: 0, end: 0 },
      insertedOnlineLink: false,
      insertedConsultation: false,
      rebookBtn: false,
      thankyouBtn: false,
      newClientBtn: false,
      week7Btn: false,
      week12Btn: false,
      week24Btn: false,
      bDayBtn: false,
      depositBtn: false,
      statusColor: 'green',
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.ncobTinyUrl) {
      this.props.getSalonOnlineSettings(this.props.salonId);
    }
  }

  componentDidMount() {
    this.props.beGetClientSmsText({ salonId: this.props.salonId });
    this.props.getSalonOnlineSettings(this.props.salonId);
    window.scrollTo(0, 0);
  }

  // noinspection JSDeprecatedSymbols
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { t } = nextProps;
    const tinyUrl = modifyUrl({ url: nextProps.ncobTinyUrl, addParams: { utm: 'sms' }, delProtocol: true });
    if (nextProps.clientSmsText) {
      this.setState({
        enableDisable: nextProps.clientSmsText.enable_sms_rebook_prompt_text,
        enableDisableThankyouBox: nextProps.clientSmsText.enable_sms_thank_you_text,
        enableDisableNewClientBox: nextProps.clientSmsText.enable_sms_new_client_thank_you_text,
        enableDisable7WeekBox: nextProps.clientSmsText.enable_sms_lapsed_7_weeks_text,
        enableDisable12WeekBox: nextProps.clientSmsText.enable_sms_lapsed_12_weeks_text,
        enableDisable24WeekBox: nextProps.clientSmsText.enable_sms_lapsed_24_weeks_text,
        enableDisableBdayBox: nextProps.clientSmsText.enable_sms_bday_clients_text,
      });
    }
    this.setState({
      defaultRebookMessage: t('clientConnect.defaultRebookMessage', {
        salon: nextProps.salonName,
        url: nextProps.ncobTinyUrl ? t('clientConnect.viaUrl', { url: tinyUrl }) : ' ',
        phone: nextProps.salonPhone ? nextProps.salonPhone : '',
      }),
      defaultTankYouMessage: t('clientConnect.defaultTankYouMessage', { salon: nextProps.salonName }),
      defaultNewClientMessage: t('clientConnect.defaultTankYouMessage', { salon: nextProps.salonName }),
      default7weekMessage: t('clientConnect.default7weekMessage', {
        salon: nextProps.salonName,
        url: nextProps.ncobTinyUrl ? t('clientConnect.viaUrl', { url: tinyUrl }) : ' ',
        phone: nextProps.salonPhone ? nextProps.salonPhone : '',
      }),
      default12weekMessage: t('clientConnect.default12weekMessage', {
        salon: nextProps.salonName,
        url: nextProps.ncobTinyUrl ? t('clientConnect.viaUrl', { url: tinyUrl }) : ' ',
        phone: nextProps.salonPhone ? nextProps.salonPhone : '',
      }),
      default24weekMessage: t('clientConnect.default24weekMessage', {
        salon: nextProps.salonName,
        url: nextProps.ncobTinyUrl ? t('clientConnect.viaUrl', { url: tinyUrl }) : ' ',
        phone: nextProps.salonPhone ? nextProps.salonPhone : '',
      }),
      defaultBdayMessage: t('clientConnect.defaultBdayMessage', {
        salon: nextProps.salonName,
        url: nextProps.ncobTinyUrl ? t('clientConnect.viaUrl', { url: tinyUrl }) : ' ',
      }),
      defaultDepositMessage: t('clientConnect.defaultDepositMessage'),
    });
  }

  onEnableClick = (prompType) => {
    const {
      enableDisable,
      defaultRebookMessage,
      enableDisableThankyouBox,
      defaultTankYouMessage,
      enableDisableNewClientBox,
      defaultNewClientMessage,
      enableDisable7WeekBox,
      default7weekMessage,
      enableDisable12WeekBox,
      default12weekMessage,
      enableDisable24WeekBox,
      default24weekMessage,
      enableDisableBdayBox,
      defaultBdayMessage,
      defaultDepositMessage,
    } = this.state;

    const buttonStates = {
      rebook: enableDisable,
      thankyou: enableDisableThankyouBox,
      newclient: enableDisableNewClientBox,
      week7: enableDisable7WeekBox,
      week12: enableDisable12WeekBox,
      week24: enableDisable24WeekBox,
      bday: enableDisableBdayBox,
    };

    const defaultMessages = {
      rebook: defaultRebookMessage,
      thankyou: defaultTankYouMessage,
      newclient: defaultNewClientMessage,
      week7: default7weekMessage,
      week12: default12weekMessage,
      week24: default24weekMessage,
      bday: defaultBdayMessage,
      deposit: defaultDepositMessage,
    };

    const clientTexts = {
      rebook: this.props.clientSmsText?.sms_rebook_prompt_text,
      thankyou: this.props.clientSmsText?.sms_thank_you_text,
      newclient: this.props.clientSmsText?.sms_new_client_thank_you_text,
      week7: this.props.clientSmsText?.sms_lapsed_7_weeks_text,
      week12: this.props.clientSmsText?.sms_lapsed_12_weeks_text,
      week24: this.props.clientSmsText?.sms_lapsed_24_weeks_text,
      bday: this.props.clientSmsText?.sms_bday_clients_text,
      deposit: this.props.clientSmsText?.deposit_request_text,
    };

    const enableDisableFunctions = {
      rebook: this.props.enableDisableRebook,
      thankyou: this.props.enableDisableThankyou,
      newclient: this.props.enableDisableNewClient,
      week7: this.props.enableDisable7Week,
      week12: this.props.enableDisable12Week,
      week24: this.props.enableDisable24Week,
      bday: this.props.enableDisableBday,
    };

    const f = buttonStates[prompType] ? 'False' : 'True';
    const messageText = clientTexts[prompType] && clientTexts[prompType].length > 0 ? clientTexts[prompType] : defaultMessages[prompType];

    enableDisableFunctions[prompType](this.props.salonId, f, messageText);
  };

  getCursorPos = (input) => {
    if ('selectionStart' in input && document.activeElement === input) {
      return {
        start: input.selectionStart,
        end: input.selectionEnd,
      };
    } else if (input.createTextRange) {
      const sel = document.selection.createRange();
      if (sel.parentElement() === input) {
        const rng = input.createTextRange();
        rng.moveToBookmark(sel.getBookmark());
        let len;
        for (len = 0; rng.compareEndPoints('EndToStart', rng) > 0; rng.moveEnd('character', -1)) {
          len += 1;
        }
        rng.setEndPoint('StartToStart', input.createTextRange());
        let pos;
        for (pos = { start: 0, end: len }; rng.compareEndPoints('EndToStart', rng) > 0; rng.moveEnd('character', -1)) {
          pos.start += 1;
          pos.end += 1;
        }
        return pos;
      }
    }
    return { start: 0, end: 0 };
  };

  showComposeModal = (prompType) => {
    const { clientSmsText } = this.props;
    const {
      sms_rebook_prompt_text,
      sms_thank_you_text,
      sms_new_client_thank_you_text,
      sms_lapsed_7_weeks_text,
      sms_lapsed_12_weeks_text,
      sms_lapsed_24_weeks_text,
      sms_bday_clients_text,
      deposit_request_text,
    } = clientSmsText || {};

    const defaultMessages = {
      rebook: this.state.defaultRebookMessage,
      thankyou: this.state.defaultTankYouMessage,
      newclient: this.state.defaultNewClientMessage,
      week7: this.state.default7weekMessage,
      week12: this.state.default12weekMessage,
      week24: this.state.default24weekMessage,
      bday: this.state.defaultBdayMessage,
      deposit: this.state.defaultDepositMessage,
    };

    const messageTexts = {
      rebook: sms_rebook_prompt_text,
      thankyou: sms_thank_you_text,
      newclient: sms_new_client_thank_you_text,
      week7: sms_lapsed_7_weeks_text,
      week12: sms_lapsed_12_weeks_text,
      week24: sms_lapsed_24_weeks_text,
      bday: sms_bday_clients_text,
      deposit: deposit_request_text,
    };

    const smsMessage = messageTexts[prompType] ? messageTexts[prompType].split('http://').join(' ') : defaultMessages[prompType];

    const buttonsState = {
      rebookBtn: prompType === 'rebook',
      thankyouBtn: prompType === 'thankyou',
      newClientBtn: prompType === 'newclient',
      week7Btn: prompType === 'week7',
      week12Btn: prompType === 'week12',
      week24Btn: prompType === 'week24',
      bDayBtn: prompType === 'bday',
      depositBtn: prompType === 'deposit',
    };

    this.setState({
      smsMessage,
      ...buttonsState,
      showTextModal: true,
    });

    this.focusCursorAtEnd();
  };

  closeClick = () => {
    this.setState({ showTextModal: false });
  };

  checkMessageLength = (text) => {
    // https://en.wikipedia.org/wiki/Quotation_mark
    const quotationMarkCharCodeList = [171, 187, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8223];
    if (text.length >= 670) {
      this.setState({ charLenLimitReached: true });
    } else {
      this.setState({ charLenLimitReached: false });
    }
    let hasEmoji = false;
    for (let i = 0; i < text.length; i += 1) {
      const c = text.charCodeAt(i);
      // emoji has high charCode, usually over 50000, to be safe, set as 5000
      if (c > 5000 && !quotationMarkCharCodeList.includes(c)) {
        hasEmoji = true;
        break;
      }
    }

    const ucas2 = punycode.encode(text);

    let numOfMessage;
    let oddCharacterSeen = false;
    for (let i = 0; i < ucas2.length; i += 1) {
      if (hasEmoji || ucas2.charCodeAt(i) > 127) {
        oddCharacterSeen = true;
        break;
      }
    }
    if (oddCharacterSeen) {
      numOfMessage = Math.ceil(text.length / 67); // 66
    } else {
      numOfMessage = Math.ceil(text.length / 153); // 132
    }

    this.setState({ smsMessage: text, numOfMessage });
    const textArea = document.getElementById(ELID.marketingSms);
    const cursorPosition = this.getCursorPos(textArea);
    this.setState({ cursorPosition });
  };

  //
  saveMessage = (setTextFunction, defaultMessage) => {
    const { smsMessage } = this.state;
    const message = smsMessage === '' ? defaultMessage : smsMessage.split('http://').join(' ');

    setTextFunction(this.props.salonId.toString(), message);
    this.setState({ showTextModal: false });
  };

  saveRebookMessage = () => {
    this.saveMessage(this.props.setRebookText, this.state.defaultRebookMessage);
  };

  saveThankyouMessage = () => {
    this.saveMessage(this.props.setThankyouText, this.state.defaultTankYouMessage);
  };

  saveNewClientMessage = () => {
    this.saveMessage(this.props.setNewClientText, this.state.defaultNewClientMessage);
  };

  save7weekMessage = () => {
    this.saveMessage(this.props.set7weekText, this.state.default7weekMessage);
  };

  save12weekMessage = () => {
    this.saveMessage(this.props.set12weekText, this.state.default12weekMessage);
  };

  save24weekMessage = () => {
    this.saveMessage(this.props.set24weekText, this.state.default24weekMessage);
  };

  saveBdayMessage = () => {
    this.saveMessage(this.props.setBdayText, this.state.defaultBdayMessage);
  };

  saveDepositMessage = () => {
    this.saveMessage(this.props.setDepositText, this.state.defaultDepositMessage);
  };

  postMessage = () => {
    const { rebookBtn, thankyouBtn, newClientBtn, week7Btn, week12Btn, week24Btn, bDayBtn, depositBtn } = this.state;

    rebookBtn && this.saveRebookMessage();
    thankyouBtn && this.saveThankyouMessage();
    newClientBtn && this.saveNewClientMessage();
    week7Btn && this.save7weekMessage();
    week12Btn && this.save12weekMessage();
    week24Btn && this.save24weekMessage();
    bDayBtn && this.saveBdayMessage();
    depositBtn && this.saveDepositMessage();
  };

  insertOnlineBooking = () => {
    const { smsMessage, insertedOnlineLink } = this.state;

    const tinyUrl = modifyUrl({ url: this.props.ncobTinyUrl, addParams: { utm: 'sms' }, delProtocol: true });
    const onlineBookingInsert = this.props.t('clientConnect.bookVia', { url: tinyUrl });

    let newMessage;
    if (!insertedOnlineLink) {
      const oldMessageBeforeCursor = smsMessage.substring(0, this.state.cursorPosition.start);
      const oldMessageAfterCursor = smsMessage.substring(this.state.cursorPosition.start, smsMessage.length);
      newMessage = `${oldMessageBeforeCursor} ${onlineBookingInsert} ${oldMessageAfterCursor} `;
    } else {
      newMessage = smsMessage.replace(onlineBookingInsert, '');
    }
    this.checkMessageLength(newMessage);
    this.setState({ smsMessage: newMessage, insertedOnlineLink: !insertedOnlineLink });
  };

  insertConsultationForm = () => {
    const { smsMessage, insertedConsultation } = this.state;
    const consultationLink = this.props.consultation_link.replace(/(^\w+:|^)\/\//, '');
    let newMessage;
    if (!insertedConsultation) {
      const oldMessageBeforeCursor = smsMessage.substring(0, this.state.cursorPosition.start);
      const oldMessageAfterCursor = smsMessage.substring(this.state.cursorPosition.start, smsMessage.length);
      newMessage = `${oldMessageBeforeCursor} ${consultationLink} ${oldMessageAfterCursor} `;
    } else {
      newMessage = smsMessage.replace(consultationLink, '');
    }
    this.checkMessageLength(newMessage);
    this.setState({ smsMessage: newMessage, insertedConsultation: !insertedConsultation });
  };

  count = () => {
    const { clientSmsText } = this.props;
    const arr = [
      clientSmsText.enable_sms_bday_clients_text,
      clientSmsText.enable_sms_lapsed_7_weeks_text,
      clientSmsText.enable_sms_lapsed_12_weeks_text,
      clientSmsText.enable_sms_lapsed_24_weeks_text,
      clientSmsText.enable_sms_new_client_thank_you_text,
      clientSmsText.enable_sms_rebook_prompt_text,
      clientSmsText.enable_sms_thank_you_text,
    ];

    let count = 0;
    for (let i = 0; i <= arr.length; i += 1) {
      if (arr[i] === true) {
        count += 1;
      }

      if (count <= 1) {
        // FIXME: do not assign directly to this.state, use this.setState
        // noinspection JSConstantReassignment
        this.state.statusColor = '#d40922'; // eslint-disable-line react/no-direct-mutation-state
      } else if (count <= 4) {
        // noinspection JSConstantReassignment
        this.state.statusColor = '#f4a637'; // eslint-disable-line react/no-direct-mutation-state
      } else if (count >= 6) {
        // noinspection JSConstantReassignment
        this.state.statusColor = '#5aa008'; // eslint-disable-line react/no-direct-mutation-state
      } else {
        // noinspection JSConstantReassignment
        this.state.statusColor = '#5aa008'; // eslint-disable-line react/no-direct-mutation-state
      }
    }

    return count;
  };

  focusCursorAtEnd = () => {
    delayed(DELAY.flash, () => {
      const textArea = this.textAreaRef && this.textAreaRef.current;
      if (textArea) {
        textArea.focus();
        const len = textArea.value.length;
        textArea.setSelectionRange(len, len);
      }
    });
  };

  render() {
    const { salonName, t } = this.props;
    const {
      enableDisable,
      enableDisableThankyouBox,
      enableDisableNewClientBox,
      enableDisable7WeekBox,
      enableDisable12WeekBox,
      enableDisable24WeekBox,
      enableDisableBdayBox,
      showTextModal,
      numOfMessage,
      smsMessage,
      charLenLimitReached,
      defaultRebookMessage,
      defaultTankYouMessage,
      defaultNewClientMessage,
      default7weekMessage,
      default12weekMessage,
      default24weekMessage,
      defaultBdayMessage,
      defaultDepositMessage,
      statusColor,
      insertedOnlineLink,
      insertedConsultation,
    } = this.state;

    const TEXT_TITLE = t('clientConnect.messageSampleTitle');

    const { consultation_link: consultationLink, auto_top_up_sms: autoTopUpSms, clientSmsText } = this.props;

    return (
      <>
        {showTextModal && (
          <>
            <div className="overlay" />
            <div className="dialog-container">
              <div className="compose-container">
                <div className="compose-header">
                  <h2>{t('clientConnect.editMessageModal.title')}</h2>
                  <div className="close-icon" role="button" tabIndex={0} onClick={this.closeClick} style={{ cursor: 'pointer' }} />
                </div>
                <div className="compose-text-area-container">
                  <textarea
                    id={ELID.marketingSms}
                    className="marketing-sms"
                    placeholder={t('clientConnect.editMessageModal.textareaPlaceholder')}
                    value={smsMessage.split('http://').join(' ')}
                    onChange={(e) => {
                      this.checkMessageLength(e.target.value);
                    }}
                    onClick={(e) => {
                      this.checkMessageLength(e.target.value);
                    }}
                    onFocus={(e) => {
                      this.checkMessageLength(e.target.value);
                    }}
                    ref={this.textAreaRef}
                  />

                  <hr />
                  <div className="m1m2-container">
                    <TooltipTextarea numOfMessage={numOfMessage} />
                    <div className="m2">
                      {consultationLink && (
                        <button className="btn btn-outline" onClick={this.insertConsultationForm}>
                          {insertedConsultation ? t('clientConnect.editMessageModal.removeConsultLinkBtn') : t('clientConnect.editMessageModal.addConsultLinkBtn')}
                        </button>
                      )}
                      <button className="btn btn-outline" onClick={this.insertOnlineBooking}>
                        {insertedOnlineLink ? t('clientConnect.editMessageModal.removeBookingLinkBtn') : t('clientConnect.editMessageModal.addBookingLinkBtn')}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="compose-footer-container">
                  <div className="disclaimer-container">
                    {charLenLimitReached && (
                      <>
                        <p className="char-limit" />
                        <p className="char-limit">{t('clientConnect.editMessageModal.textareaErrMsg1')}</p>
                        <p className="char-limit">{t('clientConnect.editMessageModal.textareaErrMsg2')}</p>
                      </>
                    )}
                  </div>
                  <div className="dialog-footer-marketing" style={{ minHeight: '40px', display: 'block', textAlign: 'center', height: 'auto' }}>
                    <button className="btn btn-violet" tabIndex={0} onClick={this.postMessage}>
                      {t('clientConnect.editMessageModal.saveMsgButton')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="client-connect-container">
          <div className="client-connect-inner">
            <section className="instruction">
              <div className="status-container">
                <div className="icon">
                  <img src={IMG_STATUS} alt="" />
                </div>
                <div className="the-text">
                  <h5>{t('clientConnect.section1Title1')}</h5>
                  <div className="instr-content client-status">
                    {t('clientConnect.descriptionPart1')} &nbsp;
                    <div id="count-num" style={{ color: statusColor }}>
                      {this.count()} / 7
                    </div>
                    &nbsp;{t('clientConnect.descriptionPart2')}&nbsp;&nbsp;
                    {!this.props.isFromMobile && (
                      <>
                        {t('clientConnect.descriptionPart3')}
                        {autoTopUpSms ? (
                          <div className="green-label info-tooltip">
                            <div>&nbsp;{t('common.enabled').toUpperCase()}.</div>
                            <TooltipCounter />
                          </div>
                        ) : (
                          <div className="red-label">
                            <div> &nbsp;{t('common.disabled').toUpperCase()}.</div>
                            <TooltipCounter />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {this.count() === 0 && (
                <div className="setups-container">
                  <div className="icon">
                    <img src={IMG_SETUP} alt="" />
                  </div>
                  <div className="the-text">
                    <h5 className="cfix">
                      <span>{t('clientConnect.section1Title2')}</span>
                      <a href="https://help.getslick.com/en/articles/3693112-setting-up-auto-client-connect-messages" className="info-tooltip" rel="noopener noreferrer" target="_blank">
                        <div className="client-info-icon" />
                      </a>
                    </h5>
                    <div className="instr-content">
                      <p>{t('clientConnect.setUpBullet1')}</p>
                      <p>{t('clientConnect.setUpBullet2')}</p>
                      <p>{t('clientConnect.setUpBullet3')}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="tc-container">
                <div className="icon">
                  <img src={IMG_TERMS} alt="" />
                </div>
                <div className="the-text">
                  <h5>{t('clientConnect.section1Title3')}</h5>
                  <div className="instr-content">
                    <p>1. {t('clientConnect.termsBulletSmsSent')}</p>

                    {!this.props.isFromMobile && (
                      <div>
                        2. {t('clientConnect.termsBulletTextBalancePart1')}
                        {S.space}
                        <SmsBundle>{t('clientConnect.termsBulletTextBalancePart2')}</SmsBundle>
                      </div>
                    )}

                    <p>
                      {this.props.isFromMobile ? '2.' : '3.'}
                      {S.space}
                      {t('clientConnect.termsBulletEnablePrompt')}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="shape">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section2Title')}</div>
                  <img src={IMG_DEPOSIT} alt="Request a deposit" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE} </div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.deposit_request_text ? clientSmsText.deposit_request_text.split('http://').join(' ') : defaultDepositMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('deposit')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section2SubTitle')}</div>
                  <div className="enable-promp-container">
                    <div className="additional-info">
                      {t('clientConnect.section2Description1')}
                      <ul className="sms-format">
                        <li>{t('clientConnect.salonName', { salon: salonName })}</li>
                        {clientSmsText?.sms_after_reminder_enabled_at ? (
                          <li>
                            {formatPartTime(clientSmsText?.sms_after_reminder_enabled_at)}
                            <Space>{formatDayToYearFullWeekdaySuffix(clientSmsText.sms_after_reminder_enabled_at)}</Space>
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                  <TooltipDeposit />
                </div>
              </div>
              <TextDeposit />
            </section>
            <section className="shape s0">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section3Title')}</div>
                  <img src={IMG_REBOOK} alt="Increase client rebookings!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE}</div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_rebook_prompt_text ? clientSmsText.sms_rebook_prompt_text.split('http://').join(' ') : defaultRebookMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('rebook')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section3SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="rebook"
                      disabled={enableDisable}
                      onClick={() => this.onEnableClick('rebook')}
                      prompt={enableDisable}
                      time={clientSmsText?.sms_rebook_prompt_text_enabled_at}
                      date={clientSmsText?.sms_rebook_prompt_text_enabled_at}
                    />
                  </div>
                  <TooltipRebook />
                </div>
              </div>
              <TextRebook />
            </section>
            <section className="shape s1">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section4Title')}</div>
                  <img src={IMG_REVIEW} alt="Boost your client reviews!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE}</div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_thank_you_text ? clientSmsText.sms_thank_you_text.split('http://').join(' ') : defaultTankYouMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('thankyou')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section4SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="thankyou"
                      disabled={enableDisableThankyouBox}
                      onClick={() => this.onEnableClick('thankyou')}
                      prompt={enableDisableThankyouBox}
                      time={clientSmsText?.sms_new_client_thank_you_text_enabled_at}
                      date={clientSmsText?.sms_new_client_thank_you_text_enabled_at}
                    />
                  </div>
                  <TooltipThankYou />
                </div>
              </div>
              <TextThankYou />
            </section>
            <section className="shape s2">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section5Title')}</div>
                  <img src={IMG_NEW_CLIENT} alt="Retain your new clients!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE} </div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">
                        {clientSmsText.sms_new_client_thank_you_text ? clientSmsText.sms_new_client_thank_you_text.split('http://').join(' ') : defaultNewClientMessage}
                      </div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('newclient')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section5SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="newclient"
                      disabled={enableDisableNewClientBox}
                      onClick={() => this.onEnableClick('newclient')}
                      prompt={enableDisableNewClientBox}
                      time={clientSmsText?.sms_thank_you_text_enabled_at}
                      date={clientSmsText?.sms_thank_you_text_enabled_at}
                    />
                  </div>
                  <TooltipNewClient />
                </div>
              </div>
              <TextNewClient />
            </section>
            <section className="shape s3">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section6Title')}</div>
                  <img src={IMG_07_WEEKS} alt="7 week client retention prompt!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE} </div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_lapsed_7_weeks_text ? clientSmsText.sms_lapsed_7_weeks_text.split('http://').join(' ') : default7weekMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('week7')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section6SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="week7"
                      disabled={enableDisable7WeekBox}
                      onClick={() => this.onEnableClick('week7')}
                      prompt={enableDisable7WeekBox}
                      time={clientSmsText?.sms_lapsed_7_weeks_text_enabled_at}
                      date={clientSmsText?.sms_lapsed_7_weeks_text_enabled_at}
                    />
                  </div>
                  <Tooltip7week />
                </div>
              </div>
              <Text7week />
            </section>
            <section className="shape s4">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section7Title')}</div>
                  <img src={IMG_12_WEEKS} alt="12 week client retention prompt!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE} </div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_lapsed_12_weeks_text ? clientSmsText.sms_lapsed_12_weeks_text.split('http://').join(' ') : default12weekMessage}</div>
                    </div>
                    <button className="btn btn-violet btn-edit-message" onClick={() => this.showComposeModal('week12')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section7SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="week12"
                      disabled={enableDisable12WeekBox}
                      onClick={() => this.onEnableClick('week12')}
                      prompt={enableDisable12WeekBox}
                      time={clientSmsText?.sms_lapsed_12_weeks_text_enabled_at}
                      date={clientSmsText?.sms_lapsed_12_weeks_text_enabled_at}
                    />
                  </div>
                  <Tooltip12week />
                </div>
              </div>
              <Text12week />
            </section>
            <section className="shape s5">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section8Title')}</div>
                  <img src={IMG_24_WEEKS} alt="24 week client retention prompt!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE}</div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_lapsed_24_weeks_text ? clientSmsText.sms_lapsed_24_weeks_text.split('http://').join(' ') : default24weekMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('week24')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section8SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="week24"
                      disabled={enableDisable24WeekBox}
                      onClick={() => this.onEnableClick('week24')}
                      prompt={enableDisable24WeekBox}
                      time={clientSmsText?.sms_lapsed_24_weeks_text_enabled_at}
                      date={clientSmsText?.sms_lapsed_24_weeks_text_enabled_at}
                    />
                  </div>
                  <Tooltip24week />
                </div>
              </div>
              <Text24week />
            </section>
            <section className="shape s6">
              <div className="prompt">
                <div className="image-container">
                  <div className="title">{t('clientConnect.section9Title')}</div>
                  <img src={IMG_CAKE} alt="Wish clients Happy Birthday!" />
                </div>
                <div className="message-container">
                  <div className="phone-img-container">
                    <div className="bubble">
                      <div className="title">{TEXT_TITLE} </div>
                      <div id="diamond-narrow" />
                      <div className="scrollable-div">{clientSmsText.sms_bday_clients_text ? clientSmsText.sms_bday_clients_text.split('http://').join(' ') : defaultBdayMessage}</div>
                    </div>
                    <button className="btn btn-violet  btn-edit-message" onClick={() => this.showComposeModal('bday')}>
                      {t('clientConnect.editMsgButton')}
                    </button>
                  </div>
                </div>
                <div className="info-container">
                  <div className="info-text">{t('clientConnect.section9SubTitle')}</div>
                  <div className="enable-promp-container">
                    <ToggleSmsButton
                      label="bday"
                      disabled={enableDisableBdayBox}
                      onClick={() => this.onEnableClick('bday')}
                      prompt={enableDisableBdayBox}
                      time={clientSmsText?.sms_bday_clients_text_enabled_at}
                      date={clientSmsText?.sms_bday_clients_text_enabled_at}
                    />
                  </div>
                  <TooltipBday />
                </div>
              </div>
              <TextBday />
            </section>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  salonName: state.currentSalon.name,
  salonPhone: state.currentSalon.phone,
  userPermission: state.salon.userPermission,
  numOfMessages: state.clientCommunications.numOfMessages,
  messageSent: state.clientCommunications.messageSent,
  isFetching: state.clientCommunications.isFetching,
  ncobTinyUrl: getNcobRedirectUrl({
    ncobTinyUrl: state.settings.onlineBooking.settingsData.ncob_tiny_url,
    salonId: state.currentSalon.id,
    isNewNcob: state.currentSalon.enabled_features?.['use_new_ncob'],
  }),
  salonOnlineBooking: state.settings.onlineBooking.settingsData.online_booking,
  consultation_link: state.currentSalon.consultation_link,
  expected_count: state.clientCommunications.expected_count,
  auto_top_up_sms: state.currentSalon.auto_top_up_sms,
  clientSmsText: state.clientCommunications.clientSmsText,
  salonDetails: state.salon,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      getSalonOnlineSettings,
      beGetClientSmsText,
      enableDisableRebook,
    },
    dispatch,
  ),

  enableDisableThankyou(salonId, enableDisableThankyouBox, text) {
    dispatch(enableDisableThankyou(salonId, enableDisableThankyouBox, text));
  },
  enableDisableNewClient(salonId, enableDisableNewClientBox, text) {
    dispatch(enableDisableNewClient(salonId, enableDisableNewClientBox, text));
  },
  enableDisable7Week(salonId, enableDisable7WeekBox, text) {
    dispatch(enableDisable7Week(salonId, enableDisable7WeekBox, text));
  },
  enableDisable12Week(salonId, enableDisable12WeekBox, text) {
    dispatch(enableDisable12Week(salonId, enableDisable12WeekBox, text));
  },
  enableDisable24Week(salonId, enableDisable24WeekBox, text) {
    dispatch(enableDisable24Week(salonId, enableDisable24WeekBox, text));
  },
  enableDisableBday(salonId, enableDisableBdayBox, text) {
    dispatch(enableDisableBday(salonId, enableDisableBdayBox, text));
  },
  setRebookText(salonId, text) {
    dispatch(setRebookText(salonId, text));
  },
  setThankyouText(salonId, text) {
    dispatch(setThankyouText(salonId, text));
  },
  setNewClientText(salonId, text) {
    dispatch(setNewClientText(salonId, text));
  },
  set7weekText(salonId, text) {
    dispatch(set7weekText(salonId, text));
  },
  set12weekText(salonId, text) {
    dispatch(set12weekText(salonId, text));
  },
  set24weekText(salonId, text) {
    dispatch(set24weekText(salonId, text));
  },
  setBdayText(salonId, text) {
    dispatch(setBdayText(salonId, text));
  },
  setDepositText(salonId, text) {
    dispatch(setDepositText(salonId, text));
  },
});

const ClientConnectLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withIsFromMobileApp(withTranslation()(ClientConnectLayout)));

export default ClientConnectLayoutHoc;
